import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { productApi } from "../../Services/Operations/ProductAPI";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function SimilarProducts({ product }) {
   const navigate = useNavigate();
  const sliderRef = useRef(null);
  console.log("SimilarProducts : ", product);
  const { configUrl } = useSelector((state) => state.cart);
  console.log("configUrl : ", configUrl);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handlePrev = () => {
    console.log("Prev Button Clicked");
    if (sliderRef.current) {
      console.log("Calling slickPrev");
      console.log(sliderRef.current);
      sliderRef.current.slickPrev();
    }
  };

  const handleNext = () => {
    console.log("Next Button Clicked");
    if (sliderRef.current) {
      console.log("Calling slickNext");
      console.log(sliderRef.current);
      sliderRef.current.slickNext();
    }
  };

    const clickProductHandler = async (categorySlug,menuSlug) => {
      if (!categorySlug || !menuSlug) {
        console.error("Invalid slugs provided:", { menuSlug, categorySlug });
        return;
      }
  
  
      try {
        console.log("menuSlug:", menuSlug, "categorySlug:", categorySlug);
        const formData = new FormData();
        formData.append("menuSlug", menuSlug);
        formData.append("categorySlug", categorySlug);
  
        const response = await productApi(formData);
        console.log("API response for product:", response);
  
        if (response.success && response.data) {
          // setProduct(response.data);
  
          console.log("Navigating to productListing with data:", response.data);
          navigate("/detailsPage/"+categorySlug)
          navigate("/detailsPage/", {
            state: {
              productData: response.data,
              menu: menuSlug,
              categoryName: categorySlug,
            },
          });
  
        } else {
          console.error("Product API response invalid or empty");
          navigate("/productListing", {
            state: {},
          });
          //toast.error("Product not found");
        }
      } catch (error) {
        console.error("Error during product API call:", error);
      }
    };

  return (
    <div
      style={{
        position: "relative",
        padding: "20px",
        maxWidth: "100%",
        margin: "0 auto",
      }}
      className="small1"
    >
      {product.similarProduct && product.similarProduct.length > 0 && (
        <p style={{fontSize:window.innerWidth<567?"20px":"35px",fontWeight:600  }}>Similar Products</p>
      )}
      {product.similarProduct && product.similarProduct.length > 0 && (
        <>
          <Slider {...settings} ref={sliderRef}>
            {product.similarProduct.map((product) => (
              <div key={product.id} style={{ padding: "10px" }}>
                <div
                  style={{
                 
                    borderRadius: "8px",
                    padding: "16px",
                    boxSizing: "border-box",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "0",
                      paddingBottom: "100%",
                    }}
                  >
                    <img
                      src={`${product.image}`}
                      alt={product.name}
                      onClick={() => {
                        clickProductHandler(
                          product.subcategory_slug,
                          product.menu_slug,
                        );
                      }}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                  <p
                    style={{
                      fontSize: "1rem",
                      fontWeight:600,
                      margin: "5px 0",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                     
                    }}
                  >
                    {product.name}
                  </p>
                   <p
                    style={{
                      fontSize:window.innerWidth<567?"0.7rem": "0.7rem",
                      fontWeight:600,
                      margin: "3px 0",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      
                      color:"gray"
                     
                    }}
                  >
                    {product.name}
                  </p>
                  <div style={{display:"flex",gap:"10px"}}>
                  <p style={{ margin: "0", color: "#000000ff",fontSize:"16px",fontWeight:600 }}>
                    ${product?.size?.price}
                  </p>
                   <p className="product-mrp" style={{ margin: "0", color: "#7e7d7dff",fontSize:"13px",fontWeight:600,textDecorationLine:"line-through" }}>
                    ${product?.size?.mrp}
                  </p>

                  <p style={{borderRadius:"10px",backgroundColor:"#ff9f9fff",color:"red",fontSize:"8px",padding:"5px"}}>-20%</p>
                  </div>

                  <p style={{fontSize:"14px",cursor:"pointer",borderBottom:"1px solid black",padding:'1px',width:"fit-content",fontWeight:700}}>Shop Now</p>
                  
                </div>
              </div>
            ))}
          </Slider>

          {/* <div style={buttonContainerStyle}>
            <div onClick={handlePrev} style={iconStyle}>
              <FaChevronLeft />
            </div>
            <div onClick={handleNext} style={iconStyle}>
              <FaChevronRight />
            </div>
          </div> */}
        </>
      )}
    </div>
  );
}

const iconStyle = {
  fontSize: "24px",
  color: "#007bff",
  cursor: "pointer",
  padding: "10px",
  background: "white",
  borderRadius: "50%",
  boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
};

const buttonContainerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
};

export default SimilarProducts;
